import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import { DatePipe } from '@angular/common';
import { of } from 'rxjs';
import * as XLSX from 'xlsx';
import { switchMap, catchError, map } from 'rxjs/operators';

@Component({
  selector: 'app-expenditure-income-report',
  standalone: false,
  templateUrl: './expenditure-income-report.component.html',
  styleUrl: './expenditure-income-report.component.scss'
})
export class ExpenditureIncomeReportComponent {
  mainexp: any;
  subexp: any;
  startDate: any;
  endDate: any;
  allvoucherdata: any;
  dr_opening_bal: any;
  currentDate: Date;
  exp_name: any;
  cr_opening_bal: any;
  credittotal: any;
  debittotal: any;


  constructor(
    private datePipe: DatePipe,
    private dialogRef: MatDialogRef<ExpenditureIncomeReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
  ) {

  }

  getFormattedDate(): string {
    return this.datePipe.transform(this.currentDate, 'dd-MM-yyyy');
  }

  exportexcel(fileName: string): void {
    const data = this.expenseArray.map(group => ({
      'तपशील': group.exp_name,
      'ऊप खाते बॅलन्स': '',
      'खर्च': group.expenses?.length && group.expenses[0].exp_type === 'Expenditure'
        ? parseFloat(group.total_final_amt.toFixed(2))
        : '',
      'जमा': group.expenses?.length && group.expenses[0].exp_type === 'Income'
        ? parseFloat(group.total_final_amt.toFixed(2))
        : ''
    }));

    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, fileName + '.xlsx');
  }


  alldebitvoucher: any

  getProfitLossAccountReport() {
    const cv: any = {
      startdate: this.startDate,
      enddate: this.endDate
    };

    this.alldebitvoucher = []; // Reset before loading

    this.service.getProfitLossAccountReport(cv).pipe(
      catchError(err => {
        console.error('Error in getProfitLossAccountReport', err);
        return of([]); // Continue with empty data
      }),
      switchMap((response1: any[]) => {
        this.alldebitvoucher = response1 || [];

        return this.service.getdataforbookbilling().pipe(
          catchError(err => {
            console.error('Error in getdataforbookbilling', err);
            return of([]);
          }),
          map(data => {
            const billingForBook = Array.isArray(data)
              ? data.filter((item: any) => {
                const invoiceDate = new Date(item.invoice_date);
                const start = new Date(this.startDate);
                const end = new Date(this.endDate);
                return (
                  parseFloat(item.invoice_total) !== 0 &&
                  invoiceDate >= start &&
                  invoiceDate <= end
                );
              }).map((item: any) => ({
                exp_name: 'पुस्तक व ग्रंथ विक्री खाते',
                sub_exp_name: '',
                final_amt: parseFloat(item.invoice_total),
                exp_type: 'Income'
              }))
              : [];

            this.alldebitvoucher = this.alldebitvoucher.concat(billingForBook);
          })
        );
      }),

      switchMap(() => {
        const req: any = {
          "start_date": this.startDate,
          "end_date": this.endDate,
          "issue_name": '',
          "issue_date": '',
        }
        return this.service.getAdvtInvoiceRegisterListbriefly(req).pipe(
          catchError(err => {
            console.error('Error in getAdvtInvoiceRegisterListbriefly', err);
            return of([]);
          }),
          map(res => {
            const billingForAdvt = Array.isArray(res)
              ? res.filter((item: any) => parseFloat(item.beforegst_amt) !== 0)
                .map((item: any) => ({
                  exp_name: 'जाहिरात खाते',
                  sub_exp_name: '',
                  final_amt: parseFloat(item.beforegst_amt),
                  exp_type: 'Income'
                }))
              : [];
            this.alldebitvoucher = this.alldebitvoucher.concat(billingForAdvt);
          })
        );
      }),

      switchMap(() => {
        const req: any = {
          "start_date": this.startDate,
          "end_date": this.endDate,
          "issue_name": '',
          "issue_date": ''
        };
        return this.service.getissueInvoiceRegisterListbriefly(req).pipe(
          catchError(err => {
            console.error('Error in getissueInvoiceRegisterListbriefly', err);
            return of([]);
          }),
          map(res => {
            const billingForIssueSeller = Array.isArray(res)
              ? res.filter((item: any) => parseFloat(item.beforegst_amt) !== 0)
                .map((item: any) => ({
                  exp_name: 'अंक विक्री',
                  sub_exp_name: '',
                  final_amt: item.beforegst_amt,
                  exp_type: 'Income'
                }))
              : [];
            this.alldebitvoucher = this.alldebitvoucher.concat(billingForIssueSeller);
          })
        );
      }),
      switchMap(() => {
        const cvv = {
          startDate: this.startDate,
          endDate: this.endDate,
          issue_seller_name: ''
        };
        return this.service.getIssuePersoanlLedBriefly(cvv).pipe(
          catchError(err => {
            console.error('Error in getIssuePersoanlLedBriefly', err);
            return of([]);
          }),
          map(res => {
            const mergedData1 = Array.isArray(res)
              ? res.filter((item: any) => parseFloat(item.credit_amt) !== 0)
                .map((item: any) => ({
                  exp_name: 'अंक विक्री क्रेडिट नोट',
                  sub_exp_name: '',
                  final_amt: (parseFloat(item.credit_amt) * -1),
                  exp_type: 'Expenditure'
                }))
              : [];
            this.alldebitvoucher = this.alldebitvoucher.concat(mergedData1);
          })
        );
      }),
      switchMap(() => {
        const req = {
          start_date: this.startDate,
          end_date: this.endDate,
          book_seller_name: ''
        };
        return this.service.getBookSellerLedgerBriefly(req).pipe(
          catchError(err => {
            console.error('Error in getBookSellerLedgerBriefly', err);
            return of([]);
          }),
          map(res => {
            const mergedData3 = Array.isArray(res)
              ? res.filter((item: any) => parseFloat(item.credit_amt) !== 0)
                .map((item: any) => ({
                  exp_name: 'पुस्तक विक्री क्रेडिट नोट',
                  sub_exp_name: '',
                  final_amt: (parseFloat(item.credit_amt) * -1),
                  exp_type: 'Expenditure'
                }))
              : [];

            this.alldebitvoucher = this.alldebitvoucher.concat(mergedData3);
          })
        );
      }),
      switchMap(() => {
        const req1 = {
          start_date: this.startDate,
          end_date: this.endDate,
          advt_name: ''
        };
        return this.service.getPersoanlLedBriefly(req1).pipe(
          catchError(err => {
            console.error('Error in getPersoanlLedBriefly (Advt)', err);
            return of([]);
          }),
          map(res => {
            const advtCreditNoteAmt = Array.isArray((res as any).data)
              ? (res as any).data
                .filter((item: any) => parseFloat(item.other_credit_amt) !== 0)
                .map((item: any) => ({
                  exp_name: 'जाहिरात क्रेडिट नोट',
                  sub_exp_name: '',
                  final_amt: (parseFloat(item.other_credit_amt) * -1),
                  exp_type: 'Expenditure'
                }))
              : [];
            const advtTdsAmount = Array.isArray((res as any).data)
              ? (res as any).data
                .filter((item: any) => parseFloat(item.tds_amt) !== 0)
                .map((item: any) => ({
                  exp_name: 'जाहिरात टी डी एस',
                  sub_exp_name: '',
                  final_amt: (parseFloat(item.tds_amt) * -1),
                  exp_type: 'Expenditure'
                }))
              : [];
            this.alldebitvoucher = this.alldebitvoucher.concat(advtCreditNoteAmt);
            this.alldebitvoucher = this.alldebitvoucher.concat(advtTdsAmount);
          })
        );
      }),
      // switchMap(() => {
      //   const request = {
      //     book_name: 'All',
      //     start_date: this.startDate,
      //     end_date: this.endDate
      //   };
      //   return this.service.getBookStockOpeningData(request).pipe(
      //     catchError(err => {
      //       console.error('Error in getBookStockOpeningData (request)', err);
      //       return of([]);
      //     }),
      //     map((data: any[]) => {
      //       const openingbookstock = Array.isArray(data)
      //         ? data.filter((item: any) => parseFloat(item.opening_value_of_book) !== 0)
      //           .map((item: any) => ({
      //             exp_name: 'प्रारंभीचा स्टॉक',
      //             sub_exp_name: '',
      //             final_amt: (parseFloat(item.opening_value_of_book) * -1),
      //             exp_type: 'Expenditure'
      //           }))
      //         : [];

      //       const closingbookstock = Array.isArray(data)
      //         ? data.filter((item: any) => parseFloat(item.value_of_book) !== 0)
      //           .map((item: any) => ({
      //             exp_name: 'अंतिम स्टॉक',
      //             sub_exp_name: '',
      //             final_amt: parseFloat(item.value_of_book),
      //             exp_type: 'Income'
      //           }))
      //         : [];

      //       this.alldebitvoucher = this.alldebitvoucher.concat(openingbookstock);
      //       this.alldebitvoucher = this.alldebitvoucher.concat(closingbookstock);

      //     })
      //   );
      // })
    ).subscribe({
      next: () => {
        this.processExpenses(); // Final call
      },
      error: (err) => {
        console.error('Unexpected error', err);
      }
    });
  }

  // getProfitLossAccountReport1() {
  //   const cv: any = {
  //     "startdate": this.startDate,
  //     "enddate": this.endDate
  //   }
  //   this.service.getProfitLossAccountReport(cv).subscribe((response) => {
  //     this.alldebitvoucher = response;
  //     this.processExpenses();
  //   });
  // }

  calculation1() {


    this.allvoucherdata.forEach(element => {
      if (element['voucher'] === 'cr') {
        this.credittotal -= Number(element['exp_amt']);
      } else if (element['voucher'] === 'dr') {
        this.debittotal -= Number(element['exp_amt']);
      }

    });
  }

  ngOnInit(): void {
    this.currentDate = new Date();
    this.startDate = this.data['startDate'];
    this.endDate = this.data['endDate'];
    this.mainexp = this.data['mainexp'];
    this.subexp = this.data['subexp'];
    this.getProfitLossAccountReport()
  }

  getdebitvocher() {
    throw new Error('Method not implemented.');
  }
  getcreditvocher() {
    throw new Error('Method not implemented.');
  }
  calculation() {
    throw new Error('Method not implemented.');
  }

  expenseMap: Map<string, { expenses: any[], total_final_amt: number }> = new Map();
  expenseArray: { exp_name: string, expenses: any[], total_final_amt: number }[] = [];
  totalExpenditure: any = 0
  totalIncome: any = 0
  processExpenses() {
    debugger
    this.expenseMap = new Map<string, { expenses: any[]; total_final_amt: number }>();

    if (!this.alldebitvoucher || this.alldebitvoucher.length === 0) {
      this.expenseArray = []; // Handle empty data case
      return;
    }

    this.alldebitvoucher
      .filter(item => item.exp_name) // Exclude empty `exp_name` values
      .forEach(item => {
        if (!this.expenseMap.has(item.exp_name)) {
          this.expenseMap.set(item.exp_name, { expenses: [], total_final_amt: 0 });
        }

        let expenseData = this.expenseMap.get(item.exp_name);
        if (expenseData) {
          expenseData.expenses.push(item);
          expenseData.total_final_amt += Number(item.final_amt) || 0; // Ensure numeric values
        }
      });

    // Convert Map to Array for easy binding in HTML
    this.expenseArray = Array.from(this.expenseMap, ([exp_name, data]) => ({
      exp_name,
      expenses: data.expenses,
      total_final_amt: data.total_final_amt
    }));

    // Sort: Income types first
    this.expenseArray.sort((a, b) => {
      const typeA = a.expenses[0]?.exp_type || '';
      const typeB = b.expenses[0]?.exp_type || '';
      return typeA === 'Income' && typeB === 'Expenditure' ? -1 :
        typeA === 'Expenditure' && typeB === 'Income' ? 1 : 0;
    });

    const customIncomeOrder = [
      'अंक विक्री', 'किरकोळ अंक विक्री', 'जाहिरात खाते', 'देणगी', 'पुस्तक व ग्रंथ विक्री खाते',
      'ONLINE अंक', 'वार्षिक', 'त्रैवार्षिक', 'पंचवार्षिक', 'कृषी विवेक वर्गणी',
      'हिंदुत्व', 'हिंदुत्व ग्रंथ मराठी', 'रा.स्व. संघ ग्रंथ', 'रा.स्व.ग्रंथ', 'रा.स्व.संघ ग्रंथ', 'रा स्व ग्रंथ - मराठी आवृत्ती',
      'रा स्व ग्रंथ - हिंदी आवृत्ती', 'राष्ट्रोत्थान 2100', 'राष्ट्रोत्थान 2500', 'राष्ट्रोस्थान मराठी ग्रंथ', 'राष्ट्रोस्थान हिन्दी ग्रंथ',
      'Magazine Post - वर्गणी', 'Magazine Post - ग्रंथ', 'कार्यालय भाडे', 'लाभांश खाते',
      'व्याज जमा खाते', 'अंतिम स्टॉक'
    ];

    const customExpenditureOrder = [
      'खरेदी खाते', 'पगार खाते', 'व्याज खाते', 'वर्तन खाते', 'वितरण खर्च खाते',
      'छपाई व स्टेशनरी खर्च', 'दुरूस्ती व देखभाल खाते', 'प्रवास खर्च', 'वाहन भाडे खाते',
      'वीज खर्च खाते', 'टेलिफोन खर्च खाते', 'लेखक मानधन खाते', 'हिशोब तपासणी फी खाते',
      'टपाल खर्च खाते', 'विमा खाते', 'कर्मचारी कल्याण खाते', 'बांधणी खर्च खाते',
      'कार्यालीन खर्च खाते', 'जाहिरात टी डी एस', 'भाडे खर्च खाते', 'बैठक खर्च',
      'मुद्रित शोधन खाते', 'व्यवसाय शुल्क (Professional Fees)', 'बँक कमिशन खाते',
      'चित्रे सजावट', 'वर्तमान पत्रे व नियतकालिके', 'कार्यक्रम खर्च खाते', 'पुस्तक खरेदी खाते',
      'संगणक दुरुस्ती व देखभाल', 'भाषांतर चार्जेस', 'व्यवसाय कर', 'मालमत्ता कर',
      'जाहिरात क्रेडिट नोट', 'पुस्तक विक्री क्रेडिट नोट', 'अंक विक्री क्रेडिट नोट',
      'संगणक प्रणाली', 'प्रवास भत्ता ( कर्मचारी )', 'पगार नियंत्रण', 'हिशेब तपासणी फी',
      'प्रारंभीचा स्टॉक'
    ];

    this.expenseArray.sort((a, b) => {
      const typeA = a.expenses[0]?.exp_type || '';
      const typeB = b.expenses[0]?.exp_type || '';

      // Same type (Income or Expenditure)
      if (typeA === typeB) {
        const nameA = a.exp_name;
        const nameB = b.exp_name;

        const customOrder = typeA === 'Income' ? customIncomeOrder : customExpenditureOrder;
        const indexA = customOrder.indexOf(nameA);
        const indexB = customOrder.indexOf(nameB);

        if (indexA !== -1 && indexB !== -1) {
          return indexA - indexB;
        } else if (indexA !== -1) {
          return -1;
        } else if (indexB !== -1) {
          return 1;
        } else {
          return nameA.localeCompare(nameB, 'mr'); // fallback for unmatched
        }
      }

      // Default order: Income first, then Expenditure
      return typeA === 'Income' ? -1 : 1;
    });

    // this.expenseArray.forEach((element: any) => {
    //   if (element.expenses[0].exp_type === 'Expenditure') {
    //     this.totalExpenditure = Number(this.totalExpenditure) + Number(element.total_final_amt);
    //   }
    //   if (element.expenses[0].exp_type === 'Income') {
    //     this.totalIncome = Number(this.totalIncome) + Number(element.total_final_amt);
    //   }
    // });
    this.calculateTotals();
    console.log("Processed Expense Array: ", this.expenseArray); // Debugging
  }

  calculateTotals() {

    if (this.expenseArray && this.expenseArray.length > 0) {
      this.expenseArray.forEach(group => {
        if (group.total_final_amt) {
          if (group.total_final_amt > 0) {
            // Credit
            this.totalIncome += Number(group.total_final_amt);
          } else if (group.total_final_amt < 0) {
            // Debit
            this.totalExpenditure += Math.abs(Number(group.total_final_amt));
          }
        }
      });
    }
  }


  getTotalAccountBalance(): number {
    return this.expenseArray.reduce((sum, group) => {
      return sum + (group.total_final_amt || 0);
    }, 0);
  }

}